import React from 'react';
import Grid from '@material-ui/core/Grid'
import {
    AutocompleteInput,
    BooleanInput,
    LongTextInput,
    ReferenceInput,
    required,
    SelectInput,
    TextInput
} from 'react-admin';

const AccessTerminalFields = props => (
    <React.Fragment>
        <Grid item xs={12} sm={12}>
            <ReferenceInput source="tenantId" validate={required()} reference="tenants" {...props} >
                <AutocompleteInput source="name"/>
            </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextInput source="name" validate={required()} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextInput source="deviceNo" validate={required()} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <BooleanInput source="enabled" {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <BooleanInput source="sendNotification" {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '80%'}} source="description" rows={10} {...props}/>
        </Grid>
        <Grid item xs={12} sm={6}>
            <SelectInput source="type"
                         label='Loại'
                         choices={[
                             {id: 'CARD', name: 'THẺ'},
                             {id: 'FACE', name: 'KHUÔN MẶT'},
                         ]}
                         defaultValue='CARD'
            />
        </Grid>
    </React.Fragment>
)

export default AccessTerminalFields
